// extracted by mini-css-extract-plugin
module.exports = {"card":"SelectCompany_card__2cWiD","title":"SelectCompany_title__2ico-","select":"SelectCompany_select__3F1Aj"};